(() => {
  if (window.hpmQuantitySummaryReady) return;
  window.hpmQuantitySummaryReady = true;

  let cartItems = [];
  const cards = () => document.querySelectorAll('.hpm-quantity-summary');

  function formatMoney(cents, currency) {
    const code = currency || 'HKD';
    try {
      return new Intl.NumberFormat('en-HK', {
        style: 'currency', currency: code,
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return `${code} ${(cents / 100).toFixed(2)}`;
    }
  }

  function offerFor(card, quantity) {
    if (Date.now() > Date.parse(card.dataset.offerEndsAt || '')) return null;
    const type = card.dataset.offerType;
    if (type === 'royal') {
      const eligibleIds=card.dataset.royalDryProductIds||'';
      const otherCount=cartItems.reduce((sum,item)=>sum+(eligibleIds.includes(`|${item.product_id}|`)?Number(item.quantity)||0:0),0);
      return quantity+otherCount>=2?{percent:10,label:'已計入 Royal Canin 乾糧2件9折'}:null;
    }

    if (type === 'orijen') {
      const otherCount = cartItems.reduce((sum, item) =>
        sum + (String(item.vendor).toLowerCase() === 'orijen' ? Number(item.quantity) || 0 : 0), 0);
      return quantity + otherCount >= 2
        ? { percent: 5, label: '已計入 Orijen 2 件 95 折' } : null;
    }

    if (type === 'hills') {
      const eligibleIds = card.dataset.hillsProductIds || '';
      const otherCount = cartItems.reduce((sum, item) =>
        sum + (eligibleIds.includes(`|${item.product_id}|`) ? Number(item.quantity) || 0 : 0), 0);
      return quantity + otherCount >= 12
        ? { percent: 10, label: '已計入 Hill’s 罐頭 12 件 9 折' } : null;
    }
    return null;
  }

  function priceFor(card, unitPrice, quantity) {
    const offer = offerFor(card, quantity);
    let total = quantity * (unitPrice - Math.round(unitPrice * (offer ? offer.percent : 0) / 100));
    let applied=offer;
    for(const rule of card.hpmGroupRules || []){
      const groups=Math.floor(quantity/rule.quantity), remainder=quantity%rule.quantity;
      if(!groups)continue;
      const residualOffer=offerFor(card,quantity);
      const candidate=groups*(unitPrice*rule.quantity-rule.savingCents)
        +remainder*(unitPrice-Math.round(unitPrice*(residualOffer?residualOffer.percent:0)/100));
      if(candidate<total){total=candidate;applied={label:`每 ${rule.quantity} 件優惠；餘數可享合資格品牌優惠`};}
    }
    return { offer:applied, total, saving: unitPrice * quantity - total };
  }

  function updateChoices(card, input, variant, quantity) {
    const choices = card.querySelector('[data-hpm-choices]');
    if (!choices) return;
    const minimum = Number.parseInt(input.min || '1', 10) || 1;
    const maximum = Number.parseInt(input.max, 10);
    const increment = Number.parseInt(input.step || '1', 10) || 1;
    let shown = 0;

    choices.querySelectorAll('[data-hpm-choice-qty]').forEach((button) => {
      const count = Number.parseInt(button.dataset.hpmChoiceQty, 10);
      const valid = count >= minimum && (!Number.isFinite(maximum) || count <= maximum)
        && (count - minimum) % increment === 0
        && !(button.hasAttribute('data-hpm-brand-choice') && ((card.hpmGroupRules || []).length>0 || Date.now()>Date.parse(card.dataset.offerEndsAt)));
      button.hidden = !valid;
      if (!valid) return;
      shown += 1;
      const price = priceFor(card, Number(variant.price), count);
      button.setAttribute('aria-pressed', String(quantity === count));
      button.querySelector('[data-hpm-choice-total]').textContent = formatMoney(price.total, card.dataset.currency);
      const original=button.querySelector('[data-hpm-choice-original]');
      original.hidden=price.saving<=0;
      original.textContent=formatMoney(Number(variant.price)*count,card.dataset.currency);
      button.querySelector('[data-hpm-choice-average]').textContent = `平均 ${formatMoney(price.total / count, card.dataset.currency)}／件`;
      const saving = button.querySelector('[data-hpm-choice-save]');
      saving.hidden = price.saving <= 0;
      saving.textContent = price.saving > 0 ? `節省 ${formatMoney(price.saving, card.dataset.currency)}` : '';
    });
    choices.hidden = !variant.available || shown < 1;
  }

  function update(card) {
    const sectionId = card.dataset.sectionId;
    const quantityForm=document.getElementById(`Quantity-Form-${sectionId}`);
    const totalHeading=card.querySelector('.hpm-quantity-summary__eyebrow');
    if(quantityForm&&totalHeading&&quantityForm.parentElement!==card)card.insertBefore(quantityForm,totalHeading);
    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    const form = document.getElementById(`product-form-${sectionId}`);
    const variantInput = form && form.querySelector('input[name="id"]');
    if (!quantityInput || !variantInput) return;

    if (!card.hpmVariants) {
      try {
        card.hpmVariants = JSON.parse(card.querySelector('.hpm-quantity-summary__variants').textContent);
      } catch (error) {
        return;
      }
    }
    const variantId = variantInput.value || card.dataset.selectedVariantId;
    const variant = card.hpmVariants.find((item) => String(item.id) === String(variantId));
    if (!variant || !Number.isFinite(Number(variant.price))) {
      card.hidden = true;
      return;
    }
    if(card.hpmRuleVariant!==String(variant.id)){
      card.hpmRuleVariant=String(variant.id);card.hpmGroupRules=[];
      loadGroupRules(card,variant.id);
    }

    const entered = Number.parseInt(quantityInput.value, 10);
    const minimum = Number.parseInt(quantityInput.min || quantityInput.dataset.min || '1', 10);
    const quantity = Number.isFinite(entered) && entered > 0 ? entered : (minimum || 1);
    const price = Number(variant.price);
    const calculation = priceFor(card, price, quantity);
    const offer = calculation.offer;
    const total = calculation.total;
    const note = card.querySelector('[data-hpm-offer-note]');

    card.hidden = !variant.available;
    card.querySelector('[data-hpm-quantity]').textContent = String(quantity);
    card.querySelector('[data-hpm-total]').textContent = formatMoney(total, card.dataset.currency);
    card.querySelector('[data-hpm-average]').textContent = formatMoney(total / quantity, card.dataset.currency);
    note.hidden = !offer;
    note.textContent = offer ? `${offer.label}；多件價與品牌優惠不重複折扣。迎新碼／積分於結帳確認資格及組合。` : '';
    updateChoices(card, quantityInput, variant, quantity);
    const bundle=window.hpmRoyalBundles&&window.hpmRoyalBundles[String(variant.id)];
    const accelerated=form.closest('product-form')?.querySelector('.shopify-payment-button');
    if(accelerated&&bundle)accelerated.hidden=true;
    if(bundle&&!bundle.ready&&quantity>=bundle.quantity){note.hidden=false;note.textContent='Test 組合價預覽：組合商品尚未開放購買，不會按單件原價代替結帳。';}

    if(card.dataset.groupLoaded==='error'){
      note.hidden=false;note.textContent='多件優惠暫未載入，實際優惠以結帳為準。';
    }
  }

  function updateAll() { cards().forEach(update); }

  async function loadGroupRules(card,id){
    try{
      const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      const bundle=window.hpmRoyalBundles&&window.hpmRoyalBundles[String(id)];
      let data;
      if(bundle){data={rules:[bundle]};}
      else{const response=await fetch(`${root}apps/hpm-loyalty/api/quantity-price?variantId=${id}`,{credentials:'same-origin'});if(!response.ok)throw Error('unavailable');data=await response.json();}if(card.hpmRuleVariant!==String(id))return;
      card.hpmGroupRules=Array.isArray(data.rules)?data.rules:[];
      const choices=card.querySelector('.hpm-quantity-summary__choices-grid');
      choices.querySelectorAll('[data-hpm-custom-choice]').forEach(e=>e.remove());
      const template=choices.querySelector('[data-hpm-choice-qty="1"]');
      for(const rule of card.hpmGroupRules){const button=template.cloneNode(true);button.dataset.hpmCustomChoice='true';button.dataset.hpmChoiceQty=rule.quantity;button.classList.add('hpm-quantity-summary__choice--offer');button.querySelector('.hpm-quantity-summary__choice-title').textContent=`${rule.quantity} 件優惠`;choices.append(button);}
      choices.querySelectorAll('[data-hpm-brand-choice]').forEach(e=>{e.hidden=card.hpmGroupRules.length>0||Date.now()>Date.parse(card.dataset.offerEndsAt)});
      card.dataset.groupLoaded='true';update(card);
    }catch(_){card.dataset.groupLoaded='error';const note=card.querySelector('[data-hpm-offer-note]');note.hidden=false;note.textContent='未能載入多件優惠，請重新整理；實際優惠以結帳為準。';}
  }

  async function refreshCart() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      cartItems = Array.isArray(cart.items) ? cart.items : [];
      updateAll();
    } catch (error) {
      // Selected-quantity estimates remain available if the cart cannot be read.
    }
  }

  function start() { updateAll(); refreshCart(); }
  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('input', (event) => {
    if (event.target.matches('.quantity__input')) updateAll();
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('.quantity__input, .product-variant-id')) updateAll();
  });
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-hpm-choice-qty]');
    if (choice && !choice.hidden) {
      const card = choice.closest('.hpm-quantity-summary');
      const input = card && document.getElementById(`Quantity-${card.dataset.sectionId}`);
      if (input) {
        input.value = choice.dataset.hpmChoiceQty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        update(card);
      }
      return;
    }
    if (event.target.closest('.quantity__button')) requestAnimationFrame(updateAll);
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshCart();
  });
  if (document.readyState !== 'loading') start();
})();
